import { render } from "./AttributionWindowBlock.vue?vue&type=template&id=0441dbe2"
import script from "./AttributionWindowBlock.vue?vue&type=script&lang=js"
export * from "./AttributionWindowBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleForm/Blocks/AttributionWindowBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0441dbe2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0441dbe2', __exports__)) {
    api.reload('0441dbe2', __exports__)
  }
  
  module.hot.accept("./AttributionWindowBlock.vue?vue&type=template&id=0441dbe2", () => {
    api.rerender('0441dbe2', render)
  })

}


export default __exports__